// src/components/InviteUserModal.js
import React, { useState, useEffect } from 'react';
import '../styles/Modal.css';
import { useAuth } from '../context/AuthContext';

const InviteUserModal = ({ onClose, onInvite }) => {
  const { user, token, logout } = useAuth();
  const [warehouses, setWarehouses] = useState([]);
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [role, setRole] = useState('User');
  const [assignedWarehouse, setAssignedWarehouse] = useState("");
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError('Email is required');
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);
    await onInvite({ 
      firstName: firstName, 
      lastName: lastName, 
      email: email, 
      phoneNumber: phoneNumber, 
      role: role,
      warehouseId: role === "Merchandiser" ? assignedWarehouse : null, 
    });
    setLoading(false);
  };

  useEffect(() => {
    const cached = sessionStorage.getItem("warehouses");

    if (cached) {
      const parsed = JSON.parse(cached);
      const l2 = parsed.filter(w => w.mainWarehouseId !== null);
      setWarehouses(l2);
      return;
    }

    const fetchWarehouses = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/Warehouse`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const data = await res.json();
        const parsed = JSON.parse(cached);
        const l2 = parsed.filter(w => w.mainWarehouseId !== null);
        setWarehouses(l2);
        sessionStorage.setItem("warehouses", JSON.stringify(data));
      } catch (err) {
        setError("Failed to fetch warehouses");
      }
    };

    fetchWarehouses();
  }, [token]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Invite Team Member</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        {error && <div className="modal-error">{error}</div>}

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">            
            <input
              type="text"
              id="firstName"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder=" "
              disabled={loading}
              autoFocus
            />
            <label htmlFor="firstName">First Name</label>
          </div>

          <div className="form-group">            
            <input
              type="text"
              id="lastName"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder=" "
              disabled={loading}
              autoFocus
            />
            <label htmlFor="lastName">Last Name</label>
          </div>

          <div className="form-group">            
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder=" "
              disabled={loading}
              autoFocus
            />
            <label htmlFor="email">Email Address</label>
          </div>

          <div className="form-group">            
            <input
              type="tel"
              id="phoneNumber"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder=" "
              disabled={loading}
              autoFocus
            />
            <label htmlFor="phoneNumber">Phone Number</label>
          </div>

          <div className="form-group">
            <select
              id="role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              disabled={loading}
            >
              <option value="User">User</option>
              <option value="Admin">Admin</option>
              <option value="Merchandiser">Merchandiser</option>
            </select>
            <label htmlFor="role">Role</label>
          </div>

          {role === "Merchandiser" && (
            <div className="form-group">
              <select
                id="assignedWarehouse"
                value={assignedWarehouse}
                onChange={(e) => setAssignedWarehouse(e.target.value)}
                disabled={loading}
              >
                <option value="">Select Warehouse...</option>

                {warehouses.map((wh) => (
                  <option key={wh.id} value={wh.id}>
                    {wh.name}
                  </option>
                ))}
              </select>

              <label htmlFor="assignedWarehouse">Assign Warehouse</label>
            </div>
          )}

          <div className="modal-actions">
            <button
              type="button"
              className="modal-button secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="modal-button primary"
              disabled={loading}
            >
              {loading ? 'Sending invitation...' : 'Send Invitation'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InviteUserModal;